import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { config } from '../config';

@Injectable({
  providedIn: 'root'
})
export class TokenValidationService {
  constructor(private http: HttpClient) { }

  /**
   * Validate token with backend by calling the current user endpoint.
   */
  validateToken(token: string): Observable<boolean> {
    if (!token) {
      return of(false);
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

    return this.http.get(`${config.baseUrl}wp/v2/users/me`, { headers }).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }

  /**
   * Decode JWT without verification and check expiration.
   */
  isTokenExpired(token: string): boolean {
    if (!token) {
      return true;
    }

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (!payload?.exp) {
        return false;
      }
      const expirationTime = payload.exp * 1000; // Convert to ms
      return Date.now() >= expirationTime;
    } catch {
      // If we can't decode, treat as expired
      return true;
    }
  }
}


